export enum ChipStatus {
    FREE = '1001',
    OCCUPIED = '1002',
    DISABLED = '1003'
}